/**
 * The text a numbered marker (parking spot, storage unit, unit) shows on a
 * drawing: only the number part of its number field, so a field like
 * "UTHYRES 202" fits the round marker as "202". The number part is the last
 * word that contains a digit ("Förråd 12A" → "12A"); a field without a digit
 * is shown whole, and an empty one as "?". The full field stays in the
 * marker's hover text and in the lists.
 */
export const markerNumber = (number: string | undefined): string => {
    const words = (number ?? '').trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return '?';
    const withDigit = [...words].reverse().find(word => /\d/.test(word));
    return withDigit ?? words.join(' ');
};
